module.exports = __webpack_public_path__ + "img/text.6fd39382.png";